/**
 * Login Page
 * ==========
 * Stetson-branded authentication page with login form.
 * Redirects to addi.vaultailab.com in production.
 */

import React from 'react';
import { LoginForm } from '../../components/auth/LoginForm';

/**
 * Login Page Component
 * Displays the Stetson-branded login form for protected routes.
 * 
 * @returns {JSX.Element} Login page
 */
function Login() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-dme-green-900 via-dme-blue-900 to-dme-blue-800 flex items-center justify-center py-12 px-4 relative overflow-hidden">
      {/* Background Pattern - Stetson Green Theme */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Green gradient orbs */}
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-dme-green/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] bg-dme-orange/10 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-dme-blue-400/10 rounded-full blur-3xl" />
        
        {/* Grid pattern overlay */}
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
                              linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
            backgroundSize: '50px 50px',
          }}
        />
      </div>
      
      {/* Stetson Logo Watermark */}
      <div className="absolute top-8 left-8 z-10">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center border border-white/20">
            <span className="text-white font-bold text-xl">S</span>
          </div>
          <div>
            <p className="text-white font-semibold">Stetson University</p>
            <p className="text-dme-green-300 text-sm">Commitment Predictor Hub</p>
          </div>
        </div>
      </div>

      {/* DME Logo - Top Right */}
      <div className="absolute top-8 right-8 z-10">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-gradient-to-br from-dme-orange to-dme-orange-dark rounded-lg flex items-center justify-center">
            <span className="text-white font-bold">D</span>
          </div>
          <span className="text-white/80 font-medium">DME</span>
        </div>
      </div>
      
      {/* Login Form */}
      <div className="relative z-10 w-full">
        <LoginForm />
      </div>

      {/* Footer Note */}
      <div className="absolute bottom-8 left-0 right-0 text-center z-10">
        <p className="text-white/40 text-sm">
          Powered by DME Delivers Commitment Predictor Hub
        </p>
        <p className="text-white/30 text-xs mt-1">
          Production: addi.vaultailab.com
        </p>
      </div>
    </div>
  );
}

export default Login;
